<template>
  <v-footer app inset fixed class="pa-4 base-footer" :class="classFooter">
    <div :class="limit">
      <slot />
    </div>
  </v-footer>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
@Component
export default class BaseFooter extends Vue {
  @Prop({ default: "white" }) color: string;
  @Prop({ default: "max-content-width" }) limit: string;
  @Prop({ default: false }) withoutSidebar: boolean;
  @State((state) => state.miniSidebarValue) miniSidebarValue!: boolean;
  get classFooter(): string {
    const paddingSidebar =
      this.$vuetify.breakpoint.mdAndDown || this.withoutSidebar
        ? "base-footer__without-sidebar"
        : this.miniSidebarValue
        ? "base-footer__sidebar-mini"
        : "base-footer__sidebar-full";
    return `${paddingSidebar} ${this.color}`;
  }
}
</script>
<style lang="sass">
.base-footer__
  &content
    border-top: 1px solid var(--v-gray15-base) !important
    left: 0px !important
  &without-sidebar
    left: 0px !important
  &sidebar-full
    left: 355px !important
  &rsidebar-mini
    left: 56px !important
</style>
